import { put } from "redux-saga/effects";
import { getEmployeeData, postEnrollFace, getAllFace } from "../../Services";

export function* getEmployeeDataSaga(action) {
  const payload = action.payload;
  try {
    const res = yield getEmployeeData(payload);
    yield put({ type: "REQ_GET_EMPLOYEE_DATA", data: res });
  } catch (e) {
    yield put({ type: "REQ_GET_EMPLOYEE_DATA_FAILED", errData: e });
  }
}

export function* enrollFaceSaga(action) {
  const payload = action.payload;
  try {
    const res = yield postEnrollFace(payload);
    yield put({ type: "REQ_POST_ENROLL_FACE", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_POST_ENROLL_FACE_FAILED", errData: e });
  }
}

export function* getAllFaceSaga(action) {
  const payload = action.payload;
  try {
    const res = yield getAllFace(payload);
    yield put({ type: "REQ_GET_ALL_FACE_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_GET_ALL_FACE_FAILED", errData: e });
  }
}
